import styled from 'styled-components'

export const Icon = styled.div`
  width: ${({ width = '30px' }) => width};
  height: ${({ height = '30px' }) => height};

  background: ${({ color = 'default', theme }) =>
    theme.icones[color] || theme.icones.default};

  cursor: ${({ cursor }) => cursor};
  transform: ${({ transform }) => transform};
  mask: ${({ nome }) => `url('${nome}') no-repeat center / contain`};
  -webkit-mask: ${({ nome }) => `url('${nome}') no-repeat center / contain`};
  mask-size: contain;
`
